const state = {
  chart: {},
  aizhan: {},
  adinfo:"",
  isCheck:true
};

const mutations = {

};

const actions = {

};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};




// WEBPACK FOOTER //
// ./src/store/seoBigData.js